import NavigatorFeedbackDialog from './NavigatorFeedback';

export const dialogMap = {
  NavigatorFeedbackDialog,
};
